<template>
  <div class="nlp__footer-box">
    <div class="nlp__footer-main">
      <div class="nlp__footer-logo">
        <NlpLogo v-if="!isNlpMobile" />
        <NlpLogoMobile v-else />
      </div>
      <div class="nlp__footer-info">
        <div class="nlp__footer-header">
          Info
        </div>
        <div
          class="nlp__footer-link"
          @click="nlpScrollToViewSelector('.nlp__why-check', -128)"
        >
          Why Check
        </div>
        <div
          class="nlp__footer-link"
          @click="nlpScrollToViewSelector('.nlp__why-satoshi', -128)"
        >
          Solutions
        </div>
        <div
          class="nlp__footer-link"
          @click="onPricingClick"
        >
          Pricing
        </div>
        <div
          class="nlp__footer-link"
          @click="nlpScrollToViewSelector('.nlp__faq', -128)"
        >
          FAQ
        </div>
      </div>
      <div class="nlp__footer-legal">
        <div class="nlp__footer-header">
          Legal
        </div>
        <router-link
          class="nlp__footer-link"
          target="_blank"
          :to="{ name: `terms-of-use-${getCurrentTermsVersion}` }"
        >
          Terms of Use
        </router-link>
        <router-link
          class="nlp__footer-link"
          target="_blank"
          :to="{ name: 'privacy-policy' }"
        >
          Privacy Policy
        </router-link>
        <router-link
          class="nlp__footer-link"
          target="_blank"
          :to="{ name: 'cookie-policy' }"
        >
          Cookie Policy
        </router-link>
      </div>
      <div class="nlp__footer-contacts">
        <div class="nlp__footer-header">
          Contact us
        </div>
        <a
          class="nlp__footer-link nlp__footer-link--underline"
          href="mailto:support@satoshieye.com"
          target="_blank"
        >
          <NlpEmail />
          support@satoshieye.com
        </a>
        <a
          class="nlp__footer-link"
          href="https://t.me/s/satoshieyeofficial"
          target="_blank"
        >
          <NlpTelegram />
          Telegram
        </a>
        <a
          class="nlp__footer-link"
          href="https://www.linkedin.com/company/satoshi-eye"
          target="_blank"
        >
          <NlpLinkedin />
          Linkedin
        </a>
        <div class="nlp__footer-link nlp__footer-link--tweet">
          <a
            class="nlp__footer-link"
            href="https://x.com/Satoshi_Eye"
            target="_blank"
          >
            <NlpTwitter />
            X (Twitter)
          </a>
          <div v-show="false">
            <a
              class="twitter-share-button"
              data-show-count="false"
              data-size="small"
              href="https://x.com/intent/tweet?text=Check%20out%20SatoshiEye&url=https%3A%2F%2Fsatoshieye.com"
            >
              Tweet
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="nlp__footer-copyright">
      © {{ getCurrentYear() }} SatoshiEye. All rights reserved.
    </div>
  </div>
</template>

<script>
// Components
import NlpLogo from '@/pages/landing-page/svg/NlpLogo.vue'
import NlpLogoMobile from '@/pages/landing-page/svg/NlpLogoMobile.vue'
import NlpEmail from '@/pages/landing-page/svg/NlpEmail.vue'
import NlpLinkedin from '@/pages/landing-page/svg/NlpLinkedin.vue'
import NlpTwitter from '@/pages/landing-page/svg/NlpTwitter.vue'
import NlpTelegram from '@/pages/landing-page/svg/NlpTelegram.vue'

// Mixins
import deviceWidthMixin from '@/assets/mixins/deviceWidthMixin'

// Utils
import { nlpScrollToViewSelector } from '@/utils/scroll-to'

// Vuex
import { mapGetters } from 'vuex'

export default {
  name: 'NlpFooter',
  components: {
    NlpLogo,
    NlpLogoMobile,
    NlpEmail,
    NlpLinkedin,
    NlpTwitter,
    NlpTelegram,
  },
  mixins: [deviceWidthMixin],
  computed: {
    ...mapGetters('termsOfUse', ['getCurrentTermsVersion']),
    ...mapGetters('user', ['isLogin']),
    ...mapGetters('payment', ['getCurrentPlan']),
    shouldRedirectPricingToChangePlan() {
      if (this.isLogin) return true
      const plan = this.getCurrentPlan
      return plan && plan.planTier !== 'free'
    },
  },
  mounted() {
    this.loadTwitterWidget()
  },
  methods: {
    nlpScrollToViewSelector,
    onPricingClick() {
      if (this.shouldRedirectPricingToChangePlan) {
        this.$router.push({ name: 'changePlan' })
      } else {
        this.nlpScrollToViewSelector('.nlp__pricing', -128)
      }
    },
    getCurrentYear() {
      return new Date().getFullYear()
    },
    loadTwitterWidget() {
      if (window.twttr) {
        window.twttr.widgets.load()
        return
      }
      const script = document.createElement('script')
      script.setAttribute('src', 'https://platform.twitter.com/widgets.js')
      script.setAttribute('async', '')
      script.setAttribute('charset', 'utf-8')
      document.head.appendChild(script)
    }
  }
}
</script>

<style scoped>
.nlp__footer-main {
  display: flex;
  flex-wrap: wrap;
  padding: 48px 0;
}
.nlp__footer-logo {
  flex: 0 0 45%;
}
.nlp__footer-logo svg {
  width: auto;
  height: 58px;
}
.nlp__footer-info,
.nlp__footer-legal {
  flex: 1 1 15%;
}
.nlp__footer-contacts {
  flex: 1 1 25%;
}
.nlp__footer-header {
  margin-bottom: 24px;
  font-weight: 700;
  font-size: 14px;
  line-height: 1;
  color: #1C1C1C;
}
.nlp__footer-link {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #5A627D;
  text-decoration: none;
  transition: color 0.3s ease;
  cursor: pointer;
}
.nlp__footer-link--underline {
  text-decoration: underline;
}
.nlp__footer-link + .nlp__footer-link {
  margin-top: 12px;
}
.nlp__footer-link svg .nlp__svg-path {
  transition: fill 0.3s ease;
}
.nlp__footer-link:hover {
  color: #1C1C1C;
}
.nlp__footer-link:hover svg .nlp__svg-path {
  fill: #1C1C1C;
}

.nlp__footer-copyright {
  padding: 32px 0;
  border-top: 1px solid #E2E9F6;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #5A627D;
}

.nlp__footer-link--tweet {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.nlp__footer-link--tweet .twitter-share-button {
  font-size: 12px;
  transform: scale(0.9);
  transform-origin: left center;
}

@media (max-width: 1279px) {
  .nlp__footer-logo {
    flex: 1 0 100%;
    margin-bottom: 40px;
  }
  .nlp__footer-info,
  .nlp__footer-legal {
    flex: 1 1 30%;
  }
  .nlp__footer-contacts {
    flex: 1 1 40%;
  }
}
@media (max-width: 767px) {
  .nlp__footer-logo svg {
    width: auto;
    height: 44px;
  }
  .nlp__footer-info,
  .nlp__footer-legal {
    flex: 1 1 50%;
    margin-bottom: 32px;
  }
  .nlp__footer-contacts {
    flex: 1 1 100%;
  }
  .nlp__footer-copyright {
    padding: 16px 0;
    border-top: 1px solid #E2E9F6;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #5A627D;
  }
}
</style>
